import React from "react";
import { useI18n } from "../../lib/i18n.jsx";
import HeroPlant from "./animations/HeroPlant.jsx";

export default function Hero({ onOpenFlora, onScrollProducts, onOpenDistribuye, onOpenRegistro }) {
  const { t } = useI18n();

  return (
    <section
      id="top"
      className="relative pt-36 pb-20 lg:pt-44 lg:pb-32 overflow-hidden"
      data-testid="hero-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-5 eu-fade-up">
          <div className="eu-data-label mb-6">
            <i className="fa-solid fa-seedling mr-2 text-[#9ead9b]"></i>
            {t.hero.eyebrow}
          </div>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl xl:text-8xl text-[#133322] leading-[0.95] tracking-tight">
            <span className="block">{t.hero.title_l1}</span>
            <span className="block italic text-[#b45f3e]">{t.hero.title_l2}</span>
          </h1>
          <p className="mt-8 max-w-xl text-lg text-[#5c6b61] leading-relaxed">
            {t.hero.subtitle}
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <button
              onClick={onScrollProducts}
              className="eu-btn-primary"
              data-testid="hero-cta-primary"
            >
              <i className="fa-solid fa-arrow-right text-xs"></i>
              {t.hero.cta_primary}
            </button>
            <button
              onClick={onOpenFlora}
              className="eu-btn-outline"
              data-testid="hero-cta-flora"
            >
              <i className="fa-solid fa-message text-xs"></i>
              {t.hero.cta_secondary}
            </button>
          </div>

          <div className="mt-6 flex flex-wrap gap-2 text-xs">
            <button
              onClick={onOpenDistribuye}
              className="inline-flex items-center gap-1.5 text-[#5c6b61] hover:text-[#133322] font-medium transition group"
              data-testid="hero-cta-distribuye"
            >
              <i className="fa-solid fa-handshake text-[#b45f3e]"></i>
              <span className="border-b border-transparent group-hover:border-[#133322]">¿Quieres ser distribuidor?</span>
              <i className="fa-solid fa-arrow-up-right-from-square text-[9px] opacity-60"></i>
            </button>
            <span className="text-[#9ead9b]">·</span>
            <button
              onClick={onOpenRegistro}
              className="inline-flex items-center gap-1.5 text-[#b45f3e] hover:text-[#133322] font-medium transition group"
              data-testid="hero-cta-registro"
            >
              <i className="fa-solid fa-seedling"></i>
              <span className="border-b border-transparent group-hover:border-[#133322]">Regístrate y obtén tu cupón 10%</span>
            </button>
          </div>

          <div className="mt-16 grid grid-cols-3 gap-6 max-w-lg border-t border-[#e5e8e2] pt-8">
            <div data-testid="hero-stat-1">
              <div className="font-display text-4xl text-[#133322]">
                {t.hero.stat1_value}
              </div>
              <div className="eu-data-label mt-2">{t.hero.stat1_label}</div>
            </div>
            <div data-testid="hero-stat-2">
              <div className="font-display text-4xl text-[#133322]">
                {t.hero.stat2_value}
              </div>
              <div className="eu-data-label mt-2">{t.hero.stat2_label}</div>
            </div>
            <div data-testid="hero-stat-3">
              <div className="font-display text-4xl text-[#133322]">
                {t.hero.stat3_value}
              </div>
              <div className="eu-data-label mt-2">{t.hero.stat3_label}</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 relative">
          <HeroPlant />

          {/* Floating EDTA·EDDHA card stays on top of the plant scene */}
          <div className="hidden sm:flex absolute -left-2 top-10 lg:-left-6 eu-card px-5 py-4 items-center gap-3 max-w-[220px] z-20">
            <i className="fa-solid fa-flask-vial text-[#b45f3e] text-xl"></i>
            <div>
              <div className="eu-data-label">EDTA · EDDHA</div>
              <div className="text-sm text-[#1c1c1c] font-medium">
                Quelatos garantizados
              </div>
            </div>
          </div>

          {/* Subtle caption pill on the right */}
          <div className="hidden md:flex absolute right-0 lg:-right-2 top-6 items-center gap-2 bg-[#133322] text-[#f7f7f4] rounded-full px-4 py-2 z-20 shadow-lg">
            <span className="h-1.5 w-1.5 rounded-full bg-green-400 animate-pulse"></span>
            <span className="font-mono-eu text-[10px] tracking-[0.2em] uppercase">
              Vida en crecimiento
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
